const styles = ({ screenSizes, spacing }) => ({
  padding: [spacing.sm, spacing.lg, 0, spacing.lg],
  textAlign: 'center',
  textTransform: 'uppercase',
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {},
});

export default styles;
